/**
 * Srdiečková fotoplatňa — konfigurátor s vlastnou fotkou (bez Google Maps)
 * -------------------------------------------------------------------------
 * - Zákazník nahrá fotku, posúva ju ťahaním a približuje kolieskom/+−
 * - Vodítko v tvare srdca ukazuje, čo bude vidno
 * - "Potvrdiť náhľad" premietne aktuálny výrez do srdca na fotke dosky
 * - Texty (mená/dátum/text navyše) sa aktualizujú živo
 * - Kontrola rozlíšenia: upozorní, ak fotka nemá dosť pixelov pre zvolenú
 *   veľkosť tlače (na rozdiel od mapy tu NEPOTREBUJEME AI upscale, pokiaľ
 *   je fotka od zákazníka dostatočne kvalitná už od začiatku)
 */

const HPP_HEART_PATH = "M 0.00000,0.29232 C -0.00001,0.33431 0.01190,0.38646 0.02331,0.42221 C 0.03568,0.46093 0.05182,0.49552 0.07047,0.52642 C 0.08023,0.54258 0.08910,0.55813 0.09968,0.57300 L 0.14747,0.63804 C 0.15359,0.64523 0.15859,0.65188 0.16446,0.65886 C 0.17041,0.66594 0.17579,0.67253 0.18189,0.67920 L 0.25405,0.75732 C 0.25691,0.76030 0.25964,0.76455 0.26267,0.76761 C 0.26600,0.77097 0.26907,0.77303 0.27223,0.77687 C 0.29484,0.80435 0.32395,0.82882 0.34636,0.85294 L 0.39451,0.89914 C 0.39775,0.90197 0.40075,0.90571 0.40378,0.90868 C 0.41980,0.92442 0.44721,0.94894 0.46103,0.96381 C 0.46429,0.96732 0.46703,0.96906 0.47067,0.97304 L 0.48985,0.99160 C 0.49285,0.99434 0.49613,0.99827 0.49965,1.00000 C 0.50261,0.99868 0.50579,0.99589 0.50783,0.99388 L 0.75769,0.75102 C 0.76856,0.74036 0.78027,0.72617 0.79068,0.71554 L 0.86575,0.62604 C 0.88262,0.60417 0.91903,0.55175 0.93193,0.52800 C 0.93380,0.52458 0.93520,0.52205 0.93702,0.51889 C 0.94258,0.50928 0.95661,0.48216 0.96004,0.47302 C 0.97388,0.43611 0.98089,0.41885 0.98984,0.37801 L 0.99566,0.34221 C 1.00769,0.26536 0.99517,0.17968 0.95228,0.11730 C 0.93747,0.09575 0.93224,0.08999 0.91456,0.07231 C 0.87560,0.03334 0.81325,0.00000 0.74370,0.00000 C 0.65826,-0.00000 0.59894,0.02958 0.54445,0.08528 C 0.54020,0.08963 0.53725,0.09332 0.53319,0.09764 C 0.52892,0.10220 0.52608,0.10483 0.52231,0.10961 L 0.50042,0.13398 C 0.49796,0.13314 0.48037,0.11219 0.47839,0.10970 L 0.45650,0.08517 C 0.45271,0.08122 0.44776,0.07734 0.44453,0.07357 C 0.43793,0.06585 0.41556,0.04837 0.40725,0.04260 C 0.33562,-0.00717 0.23307,-0.01310 0.15384,0.02793 C 0.12709,0.04179 0.10660,0.05760 0.08507,0.07753 L 0.06858,0.09481 C 0.06152,0.10306 0.05265,0.11426 0.04674,0.12347 C 0.01382,0.17477 0.00002,0.22611 0.00000,0.29232 L 0.00000,0.29232 Z";

// Cielove rozlisenie (px) potrebne pre oblast srdca pri 300 DPI, podla velkosti platne
const HPP_TARGET_HEART_PX = {
  A5: { w: 1311, h: 1265 },
  A4: { w: 1860, h: 1789 },
  A3: { w: 2631, h: 2530 }
};

let hppSize = "A4";
let hppImg = null; // nacitany <img> element (povodna fotka)
let hppNaturalW = 0;
let hppNaturalH = 0;
let hppPanX = 0;
let hppPanY = 0;
let hppUserZoom = 1;

// POZOR: script ma "defer", cim je zarucene ze DOM je uz kompletne
// naparsovany v okamihu, ked sa tento subor spusti — takze NEMA zmysel
// cakat na DOMContentLoaded (v niektorych Shopify kontextoch — napr.
// Theme Editor alebo prefetch navigacia — sa tato udalost uz nikdy
// znova nespusti, cim by sa cely init nikdy nezavolal).
initHeartPlaquePhotoPersonalizer();

function initHeartPlaquePhotoPersonalizer() {
  const root = document.querySelector(".heart-plaque--photo");
  if (!root) return;

  injectHeartClipDefPhoto();
  setupBackgroundImagePhoto(root.dataset.bgUrl);
  setupPhotoUpload();
  setupSizeButtons();
  setupFontButtons();
  bindLiveTextPhoto("hpp-names", "hpp-text-names", "names");
  bindLiveTextPhoto("hpp-date", "hpp-text-date", "date");
  bindLiveTextPhoto("hpp-extra", "hpp-text-extra", "extra");

  document.getElementById("hpp-confirm-btn").addEventListener("click", confirmHeartPhoto);
  document.getElementById("hpp-zoom-btn").addEventListener("click", openHeartLightboxPhoto);
}

function injectHeartClipDefPhoto() {
  if (document.getElementById("hp-heart-clip")) return;
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", "0");
  svg.setAttribute("height", "0");
  svg.style.position = "absolute";
  svg.innerHTML = `
    <defs>
      <clipPath id="hp-heart-clip" clipPathUnits="objectBoundingBox">
        <path d="${HPP_HEART_PATH}" />
      </clipPath>
    </defs>`;
  document.body.appendChild(svg);
}

function setupBackgroundImagePhoto(bgUrl) {
  const frame = document.getElementById("hpp-preview-frame");
  if (!frame || !bgUrl) return;
  const img = document.createElement("img");
  img.src = bgUrl;
  img.className = "heart-plaque__bg-img";
  img.alt = "Dubová platňa";
  frame.insertBefore(img, frame.firstChild);
}

/** Nahratie fotky + drag/zoom editor */
function setupPhotoUpload() {
  const input = document.getElementById("hpp-photo-input");
  const editor = document.getElementById("hpp-photo-editor");
  const emptyState = document.getElementById("hpp-photo-empty");

  input.addEventListener("change", () => {
    const file = input.files && input.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const rawImg = new Image();
      rawImg.onload = () => {
        removeWhiteBackgroundPhoto(rawImg).then((processedImg) => {
          hppImg = processedImg;
          hppNaturalW = processedImg.naturalWidth;
          hppNaturalH = processedImg.naturalHeight;
          hppPanX = 0;
          hppPanY = 0;
          hppUserZoom = 1;

          emptyState.style.display = "none";
          editor.innerHTML = "";
          processedImg.className = "heart-plaque__photo-editor-img";
          processedImg.draggable = false;
          editor.appendChild(processedImg);
          addZoomButtonsToEditor(editor);
          addHeartGuideOverlayPhoto(editor);
          applyEditorTransform(editor, processedImg);
          resetConfirmedStatePhoto();
        });
      };
      rawImg.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });

  setupEditorDrag(editor);
  editor.addEventListener("wheel", (e) => {
    if (!hppImg) return;
    e.preventDefault();
    hppUserZoom = clampPhoto(hppUserZoom - e.deltaY * 0.0015, 1, 4);
    clampPan(editor);
    applyEditorTransform(editor, editor.querySelector(".heart-plaque__photo-editor-img"));
  }, { passive: false });
}

/** Dasovane srdce nad editorom fotky — len vizualny navod, nic neoreza */
function addHeartGuideOverlayPhoto(editor) {
  const guide = document.createElement("div");
  guide.className = "heart-plaque__map-guide";
  guide.innerHTML = `
    <svg viewBox="0 0 1 1" preserveAspectRatio="none">
      <path d="${HPP_HEART_PATH}" />
    </svg>`;
  editor.appendChild(guide);
}

/**
 * Odstráni bielu/skoro-bielu farbu z fotky a nahradí ju priehľadnosťou
 * ÚMERNOU reálnemu pokrytiu CMY atramentom (nie len "jasu" pixela) —
 * presne rovnaký princíp ako produkčný remove_white.py skript, len priamo
 * v prehliadači, aby to zákazník videl živo v náhľade.
 *
 * Prečo nie jednoducho "jas" (luminance)? Modrá zložka má v luminancii
 * len 11% váhu, takže napr. teplo osvetlené biele šaty (nižšia modrá
 * zložka) by sa vyhodnotili ako "veľmi jasné/biele" a úplne zmizli, hoci
 * majú reálny farebný odtieň, ktorý by sa dal vytlačiť. Namiesto toho
 * počítame skutočné pokrytie atramentom C/M/Y (1-R, 1-G, 1-B) a
 * priehľadnosť znižujeme POMEROVO — čím menej atramentu treba, tým viac
 * presvitá drevo (nie ostrý zlom biela/nebiela).
 */
function removeWhiteBackgroundPhoto(img, strength = 0.35) {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      const c = 1 - data[i] / 255;
      const m = 1 - data[i + 1] / 255;
      const y = 1 - data[i + 2] / 255;
      const coverage = Math.max(c, m, y); // najvacsia potrebna zlozka atramentu
      const opacityFactor = Math.min(Math.max(coverage / strength, 0), 1);
      data[i + 3] = data[i + 3] * opacityFactor;
    }

    ctx.putImageData(imageData, 0, 0);

    const processedImg = new Image();
    processedImg.onload = () => resolve(processedImg);
    processedImg.src = canvas.toDataURL("image/png");
  });
}

function addZoomButtonsToEditor(editor) {
  const controls = document.createElement("div");
  controls.className = "hp-lightbox-zoom-controls";
  controls.style.position = "absolute";
  controls.style.bottom = "8px";
  controls.style.right = "8px";
  controls.style.zIndex = "6";

  const plus = document.createElement("button");
  plus.type = "button";
  plus.className = "hp-lightbox-zoom-btn";
  plus.textContent = "+";
  plus.addEventListener("click", (e) => {
    e.preventDefault();
    hppUserZoom = clampPhoto(hppUserZoom + 0.3, 1, 4);
    clampPan(editor);
    applyEditorTransform(editor, editor.querySelector(".heart-plaque__photo-editor-img"));
  });

  const minus = document.createElement("button");
  minus.type = "button";
  minus.className = "hp-lightbox-zoom-btn";
  minus.textContent = "−";
  minus.addEventListener("click", (e) => {
    e.preventDefault();
    hppUserZoom = clampPhoto(hppUserZoom - 0.3, 1, 4);
    clampPan(editor);
    applyEditorTransform(editor, editor.querySelector(".heart-plaque__photo-editor-img"));
  });

  controls.appendChild(minus);
  controls.appendChild(plus);
  editor.appendChild(controls);
}

function setupEditorDrag(editor) {
  let dragging = false;
  let startX = 0;
  let startY = 0;
  let startPanX = 0;
  let startPanY = 0;

  editor.addEventListener("pointerdown", (e) => {
    if (!hppImg) return;
    dragging = true;
    editor.classList.add("is-dragging");
    editor.setPointerCapture(e.pointerId);
    startX = e.clientX;
    startY = e.clientY;
    startPanX = hppPanX;
    startPanY = hppPanY;
  });

  editor.addEventListener("pointermove", (e) => {
    if (!dragging) return;
    hppPanX = startPanX + (e.clientX - startX);
    hppPanY = startPanY + (e.clientY - startY);
    clampPan(editor);
    applyEditorTransform(editor, editor.querySelector(".heart-plaque__photo-editor-img"));
  });

  const stopDrag = (e) => {
    dragging = false;
    editor.classList.remove("is-dragging");
  };
  editor.addEventListener("pointerup", stopDrag);
  editor.addEventListener("pointercancel", stopDrag);
}

// Mala bezpecnostna rezerva — fotka mierne PRESAHUJE hranicu srdca namiesto
// tesneho dosiahnutia po okraj. Bez tejto rezervy sa pri okrajovych
// pripadoch (zaokruhlovanie, mierne odlisne meranie boxu pri clip-path vs.
// SVG viewport) mohla objavit tenka medzera s presvitajucim drevom presne
// v hrotoch srdca — teraz je vzdy o kusok navyse, takze medzera nevznikne.
const HPP_OVERSCAN = 1.03;

function baselineScale(editor) {
  const cw = editor.clientWidth;
  const ch = editor.clientHeight;
  return Math.max(cw / hppNaturalW, ch / hppNaturalH) * HPP_OVERSCAN;
}

function clampPan(editor) {
  const scale = baselineScale(editor) * hppUserZoom;
  const dispW = hppNaturalW * scale;
  const dispH = hppNaturalH * scale;
  const maxPanX = Math.max(0, (dispW - editor.clientWidth) / 2);
  const maxPanY = Math.max(0, (dispH - editor.clientHeight) / 2);
  hppPanX = clampPhoto(hppPanX, -maxPanX, maxPanX);
  hppPanY = clampPhoto(hppPanY, -maxPanY, maxPanY);
}

function applyEditorTransform(editor, imgEl) {
  if (!imgEl) return;
  const scale = baselineScale(editor) * hppUserZoom;
  imgEl.style.width = `${hppNaturalW}px`;
  imgEl.style.height = `${hppNaturalH}px`;
  imgEl.style.transform =
    `translate(-50%, -50%) scale(${scale}) translate(${hppPanX / scale}px, ${hppPanY / scale}px)`;
  checkResolution(editor, scale);
}

function checkResolution(editor, scale) {
  const warning = document.getElementById("hpp-resolution-warning");
  if (!hppImg) {
    warning.classList.remove("is-visible");
    return;
  }
  const visibleNaturalW = editor.clientWidth / scale;
  const target = HPP_TARGET_HEART_PX[hppSize];
  if (visibleNaturalW < target.w) {
    warning.classList.add("is-visible");
  } else {
    warning.classList.remove("is-visible");
  }
}

function setupSizeButtons() {
  document.querySelectorAll(".hpp-size-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".hpp-size-btn").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      hppSize = btn.dataset.size;
      document.getElementById("hpp-prop-size").value = hppSize;
      const editor = document.getElementById("hpp-photo-editor");
      if (hppImg) checkResolution(editor, baselineScale(editor) * hppUserZoom);
    });
  });
}

function setupFontButtons() {
  document.querySelectorAll(".hpp-font-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".hpp-font-btn").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      const fontKey = btn.dataset.font;
      const frame = document.getElementById("hpp-preview-frame");
      frame.classList.remove("hp-font-script", "hp-font-print");
      frame.classList.add(fontKey === "print" ? "hp-font-print" : "hp-font-script");
      document.getElementById("hpp-prop-font").value = fontKey === "print" ? "Tlačený" : "Písaný";
    });
  });
}

function bindLiveTextPhoto(inputId, overlaySpanId, suffix) {
  const input = document.getElementById(inputId);
  input.addEventListener("input", () => {
    let span = document.getElementById(overlaySpanId);
    if (!span) {
      span = document.createElement("div");
      span.id = overlaySpanId;
      span.className = `heart-plaque__text-overlay heart-plaque__text-${suffix}`;
      document.getElementById("hpp-preview-frame").appendChild(span);
    }
    span.textContent = input.value;
  });
}

function resetConfirmedStatePhoto() {
  document.getElementById("hpp-add-to-cart-btn").disabled = true;
  const clip = document.getElementById("hpp-photo-preview-clip");
  if (clip) clip.style.display = "none";
  const outline = document.getElementById("hpp-photo-preview-outline");
  if (outline) outline.style.display = "none";
  document.getElementById("hpp-preview-placeholder").style.display = hppImg ? "none" : "block";
}

/** Premietne aktualny vyrez (pan/zoom) z laveho editora do srdca na doske vpravo */
function confirmHeartPhoto() {
  if (!hppImg) return;
  const editor = document.getElementById("hpp-photo-editor");
  const scale = baselineScale(editor) * hppUserZoom;

  let clip = document.getElementById("hpp-photo-preview-clip");
  if (!clip) {
    clip = document.createElement("div");
    clip.id = "hpp-photo-preview-clip";
    clip.className = "heart-plaque__photo-clip";
    document.getElementById("hpp-preview-frame").appendChild(clip);
  }
  clip.innerHTML = "";

  const previewImg = hppImg.cloneNode(true);
  clip.appendChild(previewImg);
  clip.style.display = "block";

  // Cerveny obrys srdca navrchu — samostatny prvok, aby neprekazal orezu
  let outline = document.getElementById("hpp-photo-preview-outline");
  if (!outline) {
    outline = document.createElement("div");
    outline.id = "hpp-photo-preview-outline";
    outline.className = "heart-plaque__photo-outline";
    outline.innerHTML = `
      <svg viewBox="0 0 1 1" preserveAspectRatio="none">
        <path d="${HPP_HEART_PATH}" />
      </svg>`;
    document.getElementById("hpp-preview-frame").appendChild(outline);
  }
  outline.style.display = "block";

  // Rovnaky vypocet transformacie, len vzhladom na rozmery cielovej (srdcovej) oblasti
  const applyToClip = () => {
    const cw = clip.clientWidth;
    const ch = clip.clientHeight;
    const clipBaseline = Math.max(cw / hppNaturalW, ch / hppNaturalH) * HPP_OVERSCAN;
    const clipScale = clipBaseline * hppUserZoom;
    // Preskalovanie panu z editora (inych rozmerov) do klipovej oblasti pomerovo
    const ratio = clipBaseline / baselineScale(editor);
    const scaledPanX = hppPanX * ratio;
    const scaledPanY = hppPanY * ratio;

    previewImg.style.width = `${hppNaturalW}px`;
    previewImg.style.height = `${hppNaturalH}px`;
    previewImg.style.position = "absolute";
    previewImg.style.top = "50%";
    previewImg.style.left = "50%";
    previewImg.style.transform =
      `translate(-50%, -50%) scale(${clipScale}) translate(${scaledPanX / clipScale}px, ${scaledPanY / clipScale}px)`;
  };
  applyToClip();

  document.getElementById("hpp-preview-placeholder").style.display = "none";
  document.getElementById("hpp-prop-pan-x").value = hppPanX.toFixed(1);
  document.getElementById("hpp-prop-pan-y").value = hppPanY.toFixed(1);
  document.getElementById("hpp-prop-photo-scale").value = hppUserZoom.toFixed(2);
  document.getElementById("hpp-add-to-cart-btn").disabled = false;
}

function openHeartLightboxPhoto() {
  const frame = document.getElementById("hpp-preview-frame");
  if (!frame) return;

  const overlay = document.createElement("div");
  overlay.className = "hp-lightbox-overlay";

  const wrap = document.createElement("div");
  wrap.className = "hp-lightbox-wrap";

  const clone = frame.cloneNode(true);
  clone.removeAttribute("id");
  clone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
  const nestedZoomBtn = clone.querySelector(".heart-plaque__zoom-btn");
  if (nestedZoomBtn) nestedZoomBtn.remove();
  clone.classList.add("hp-lightbox-frame-clone");
  wrap.appendChild(clone);

  let scale = 1;
  const applyScale = () => { wrap.style.transform = `scale(${scale})`; };

  const zoomControls = document.createElement("div");
  zoomControls.className = "hp-lightbox-zoom-controls";
  const zoomInBtn = document.createElement("button");
  zoomInBtn.type = "button";
  zoomInBtn.className = "hp-lightbox-zoom-btn";
  zoomInBtn.textContent = "+";
  zoomInBtn.addEventListener("click", () => { scale = Math.min(scale + 0.4, 3); applyScale(); });
  const zoomOutBtn = document.createElement("button");
  zoomOutBtn.type = "button";
  zoomOutBtn.className = "hp-lightbox-zoom-btn";
  zoomOutBtn.textContent = "−";
  zoomOutBtn.addEventListener("click", () => { scale = Math.max(scale - 0.4, 1); applyScale(); });
  zoomControls.appendChild(zoomOutBtn);
  zoomControls.appendChild(zoomInBtn);

  overlay.addEventListener("wheel", (e) => {
    e.preventDefault();
    scale = Math.min(Math.max(scale - e.deltaY * 0.001, 1), 3);
    applyScale();
  }, { passive: false });

  const closeBtn = document.createElement("button");
  closeBtn.className = "hp-lightbox-close";
  closeBtn.textContent = "✕";
  closeBtn.setAttribute("aria-label", "Zavrieť");
  closeBtn.addEventListener("click", () => overlay.remove());

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) overlay.remove();
  });

  overlay.appendChild(wrap);
  overlay.appendChild(zoomControls);
  overlay.appendChild(closeBtn);
  document.body.appendChild(overlay);
}

function clampPhoto(value, min, max) {
  return Math.min(Math.max(value, min), max);
}